import React, { Component } from 'react';
import './titleWithIconBar.scss';

export default class TitleWithIconBar extends Component {

    render = () => {
        const {className, children, ...otherProps} = this.props;
        //console.log("rerender2", this.props);
        return (
            <div className={`title-with-icon-bar ${className ? className : ''}`} {...otherProps}>
                <div className="title-with-icon-bar-title">
                    {this.props.title}
                </div>
                <div className="title-with-icon-bar-icon-bar">
                    {children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/views/titleWithIconBar/TitleWithIconBar.js